import { Box, Typography } from "@mui/material";
import React, { useRef } from "react";
import Slider from "react-slick";
import { motion, useInView } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import podar from "../../../../assets/podar1.png";

const features = [
  {
    icon: "https://www.littlemillennium.com/assets/img/slider/structured-learning.webp",
    title: "Play Based Learning",
    description: "Learn through fun play-based activities.",
    bgColor: "#fff",
  },
  {
    icon: "https://www.littlemillennium.com/assets/img/slider/safety-security.webp",
    title: "Safety And Security",
    description: "Safety is our top priority.",
    bgColor: "#fff",
  },
  {
    icon: "https://www.littlemillennium.com/assets/img/slider/all-round-development.webp",
    title: "All Round Development",
    description: "Balanced growth for your child.",
    bgColor: "#fff",
  },
  {
    icon: "https://www.littlemillennium.com/assets/img/slider/well-trained-teachers.webp",
    title: "Well Trained Teachers",
    description: "Highly trained and caring teachers.",
    bgColor: "#fff",
  },
  {
    icon: "https://www.littlemillennium.com/assets/img/slider/structured-curriculum.webp",
    title: "Structured Curriculum",
    description: "Scientifically developed curriculum.",
    bgColor: "#fff",
  },
];

const ChooseUs = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const isInView1 = useInView(ref1, { once: false });
  const isInView2 = useInView(ref2, { once: false });

  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url("https://www.littlemillennium.com/assets/img/background/bg6.webp")`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#fff",
          py: 10,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: { xs: -15, md: -25 },
          }}
        >
          <Box
            component="img"
            src={podar}
            alt="podar"
            sx={{
              width: { xs: 100, md: 250 },
              height: { xs: 100, md: 250 },
              objectFit: "contain",
            }}
          />
        </Box>
        {/* Animated Heading and Paragraph */}
        <Box
          ref={ref1}
          component={motion.div}
          initial={{ opacity: 0, y: 50 }}
          animate={isInView1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            align="center"
            fontWeight="bold"
            sx={{ color: "#000", fontSize: { xs: 25, md: 35 }, mb: 1 }}
          >
            Why Choose Us
          </Typography>

          <Typography
            align="center"
            sx={{
              maxWidth: 900,
              mx: "auto",
              color: "#000",
              mb: 6,
              fontWeight: 400,
            }}
          >
            Choosing the right preschool is a decision every parent must make to
            ensure early childhood development of their child.
          </Typography>
        </Box>

        {/* Animated Slider */}
        <Box
          ref={ref2}
          component={motion.div}
          initial={{ opacity: 0, y: 50 }}
          animate={isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 1, delay: 0.2 }}
          sx={{ maxWidth: 1200, mx: "auto", px: 2 }}
        >
          <Slider {...settings}>
            {features.map((feature, index) => (
              <Box
                key={index}
                sx={{
                  textAlign: "center",
                  px: 2,
                }}
              >
                <Box
                  sx={{
                    width: 150,
                    height: 150,
                    borderRadius: "50%",
                    backgroundColor: feature.bgColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    boxShadow: 3,
                    mt: 2,
                  }}
                >
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    style={{ width: "auto", height: "auto" }}
                  />
                </Box>
                <Typography
                  sx={{
                    mt: 2,
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: 19,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  sx={{
                    mt: 1,
                    color: "#000",
                    width: "auto",
                    textAlign: "center",
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </>
  );
};

export default ChooseUs;

